/**
 * Firebase client configuration — values come from environment variables
 * so each customer deployment can use its own Firebase project.
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

/** Application branding from environment */
export const appConfig = {
  name: process.env.REACT_APP_APP_NAME || 'Storykin',
  clientUrl: process.env.REACT_APP_CLIENT_URL || 'https://learn.storykin.app',
  logoPath: process.env.REACT_APP_LOGO_PATH || '/images/storykin_logo.png',
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#0A4872'
};

export default firebaseConfig;
